// extracted by mini-css-extract-plugin
export default {"article":"article__rObTF","spacer":"spacer__E2Lgb"};